"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _EditPassengersWidget = _interopRequireDefault(require("../../03_organisms/EditPassengersWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MobileEditPassengersPage = function MobileEditPassengersPage(_ref) {
  var _ref$userPassengerId = _ref.userPassengerId,
      userPassengerId = _ref$userPassengerId === void 0 ? null : _ref$userPassengerId,
      _ref$savedPassengers = _ref.savedPassengers,
      savedPassengers = _ref$savedPassengers === void 0 ? [] : _ref$savedPassengers,
      _ref$onPassengerEdit = _ref.onPassengerEdit,
      onPassengerEdit = _ref$onPassengerEdit === void 0 ? function () {} : _ref$onPassengerEdit,
      _ref$addPassengerLink = _ref.addPassengerLink,
      addPassengerLink = _ref$addPassengerLink === void 0 ? '' : _ref$addPassengerLink,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      t = _ref.translator;
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Edit known passengers'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_EditPassengersWidget["default"], {
    userPassengerId: userPassengerId,
    savedPassengers: savedPassengers,
    // onPassengerDelete,
    onPassengerEdit: onPassengerEdit,
    addPassengerLink: addPassengerLink,
    onBack: onBack,
    translator: t
  }));
};

var _default = MobileEditPassengersPage;
exports["default"] = _default;